/* B2B PLP redesign (2026-09-03) — runs after convermax-inject-scripts.js.
 *
 * Works inside the Convermax-rendered search/collection page:
 *   - card header: brand · style eyebrow, short title, SKU / UPC block,
 *   - toolbar: "204 wheels for 2020 GMC Sierra 1500", search-within-results,
 *     Grid / Table labels
 *   - sidebar: "Search filters" box, "Clear all (n)"
 *   - table view: header row, per-row checkbox, bulk "Add selected to cart"
 * Convermax re-renders the grid on every facet change, so everything here is
 * idempotent and re-run from a MutationObserver, like the inject script.
 */
(function () {
  var CHECK_SVG =
    '<svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 10.5l4 4 8-9"/></svg>';
  var SEARCH_SVG =
    '<svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" aria-hidden="true"><circle cx="9" cy="9" r="5.5"/><path d="M13 13l4.5 4.5"/></svg>';
  var CART_SVG =
    '<svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M2 3h2.2l2 10.5h9.6L18 6H5.2"/><circle cx="8" cy="16.5" r="1.3"/><circle cx="14.5" cy="16.5" r="1.3"/></svg>';

  function loggedIn() { return document.body.classList.contains('customer-logged-in'); }

  function skuLabel(item) {
    if (!item) return 'item';
    var value = item.querySelector('.sku-value');
    if (value && value.textContent.trim()) return value.textContent.trim();
    var container = item.querySelector('.cm_product-item__sku-container');
    if (container) {
      var text = container.textContent.replace(/sku\s*:?\s*/ig, ' ').replace(/\s+/g, ' ').trim();
      if (text) return text;
    }
    return 'item';
  }

  function vehicleFromUrl() {
    var raw = window.location.search.replace(/^\?/, '').split('&')[0];
    if (!raw) return null;
    var seg = raw.split('/').map(function (s) { try { return decodeURIComponent(s); } catch (e) { return s; } });
    var v = {};
    seg.forEach(function (s, i) {
      if (s === 'Year') v.year = seg[i + 1];
      if (s === 'Make') v.make = seg[i + 1];
      if (s === 'Model') v.model = seg[i + 1];
    });
    return v.year && v.make && v.model ? v : null;
  }
  function vehicleLabel(v) { return v ? (v.year + ' ' + v.make + ' ' + String(v.model).replace(/-/g, ' ')) : ''; }

  /* ------------------------------------------------------------ cards */
  function upgradeCard(item) {
    if (item.hasAttribute('data-plp-upgraded')) return;
    var details = item.querySelector('.cm_product-item__details');
    var eyebrow = item.querySelector('.cm-card-eyebrow');
    var title = item.querySelector('.cm_product-item__title');
    if (!details || !eyebrow || !title) return;   // inject script not done yet
    item.setAttribute('data-plp-upgraded', '1');

    // Short title: "22x9 CA80 Chrome - 6x139.7 +31ET" -> "22x9 CA80 Chrome"
    var full = title.textContent.trim();
    if (full.indexOf(' - ') > 0) {
      title.setAttribute('title', full);
      title.textContent = full.split(' - ')[0];
    }

    // Codes block (SKU / UPC) moves out of the eyebrow, under the title
    var codes = document.createElement('div');
    codes.className = 'cm-card-codes';
    var sku = eyebrow.querySelector('.cm_product-item__sku-container');
    if (sku) codes.appendChild(sku);
    title.insertAdjacentElement('afterend', codes);
    var upc = eyebrow.querySelector('.cm-card-upc');
    if (upc) codes.appendChild(upc);

    // Style in the eyebrow (from the classifier, may arrive later)
    var styleEl = document.createElement('span');
    styleEl.className = 'cm-card-style';
    eyebrow.appendChild(styleEl);
    var applyStyle = function (data) {
      if (data && data.style) { styleEl.textContent = data.style; eyebrow.classList.add('has-style'); }
    };
    if (item.__cmExtras) applyStyle(item.__cmExtras);
    item.addEventListener('cm:extras', function (e) { applyStyle(e.detail); });

    // "Add" label on the cart button (icon-only today)
    var cartBtn = item.querySelector('.cm-card-cart-btn');
    if (cartBtn && !cartBtn.querySelector('.cm-card-cart-label')) {
      var lbl = document.createElement('span');
      lbl.className = 'cm-card-cart-label';
      lbl.textContent = 'Add';
      cartBtn.appendChild(lbl);
    }
  }

  function shortenTitle(item) {
    var title = item.querySelector('.cm_product-item__title');
    if (!title) return;
    var text = title.textContent.trim();
    if (text.indexOf(' - ') > 0) {
      if (!title.getAttribute('title')) title.setAttribute('title', text);
      title.textContent = text.split(' - ')[0];
    }
  }

  function lateUpgrades(item) {
    shortenTitle(item);
    // Pieces that depend on the inject script's async classifier work.
    var upc = item.querySelector('.cm-card-eyebrow .cm-card-upc');
    var codes = item.querySelector('.cm-card-codes');
    if (upc && codes) codes.appendChild(upc);

    var cartBtn = item.querySelector('.cm-card-cart-btn');
    if (cartBtn && !cartBtn.querySelector('.cm-card-cart-label')) {
      var lbl = document.createElement('span');
      lbl.className = 'cm-card-cart-label';
      lbl.textContent = 'Add';
      cartBtn.appendChild(lbl);
    }

    // Akshay 10-27 #2: fitment is already shown above the results, not on each card.

    // Shorter warehouse labels: "In Stock (Florida) 60" -> "Florida 60", "Out of Stock (Texas)" -> "Texas Out"
    item.querySelectorAll('.cm-card-stock-text').forEach(function (t) {
      var m = t.textContent.match(/^(In Stock|Out of Stock) \((Florida|Texas)\)$/);
      if (!m) return;
      t.textContent = m[2];
      t.setAttribute('data-short', m[2] === 'Florida' ? 'FL' : 'TX'); // phone grid shows FL / TX so both fit on one line
      if (m[1] === 'Out of Stock' && !t.nextElementSibling) {
        var out = document.createElement('span');
        out.className = 'cm-card-stock-qty is-out-label';
        out.textContent = 'Out';
        t.parentElement.appendChild(out);
      }
    });

    // Akshay 10-27 #1: the classifier's Shopify availability/policy, not warehouse counts,
    // decides whether Notify me may replace Add. Do not use the cart button's temporary disabled state.
    var inventory = item.__cmExtras && item.__cmExtras.inventory;
    var sellable = inventory && (inventory.available === true || inventory.policy === 'continue');
    var bothNotify = item.querySelector('.cm-card-notify:not(.cm-card-notify--one)');
    if (sellable && bothNotify) bothNotify.remove();

    // Notify me (2026-10-13 call): also when only one warehouse is out. Both out and unsellable: one "Notify me"
    // (any warehouse; in table view it takes the qty + Add slot). One out: "Notify me when Texas has
    // stock" under the stock line, grid view only (the table row has no room). Dealer-only, like the PDP.
    var stockRows = item.querySelectorAll('.cm-card-stock-row');
    if (loggedIn() && stockRows.length === 2 && !item.querySelector('.cm-card-notify')) {
      var outRows = [].filter.call(stockRows, function (r) { return r.classList.contains('is-out'); });
      if (outRows.length === 1 || (outRows.length === 2 && !sellable)) {
        var notify = document.createElement('a');
        notify.href = '#';
        notify.setAttribute('data-plp-notify', '');
        var skuEl = item.querySelector('.sku-value');
        if (skuEl) notify.setAttribute('data-notify-sku', skuEl.textContent.trim());
        if (outRows.length === 2) {
          notify.className = 'cm-card-notify';
          notify.textContent = 'Notify me';
          notify.setAttribute('data-notify-location', 'Any warehouse');
        } else {
          var where = outRows[0].querySelector('.cm-card-stock-text').textContent.trim();
          notify.className = 'cm-card-notify cm-card-notify--one';
          // Phone hides the "when Texas has stock" part; the link sits right after the out warehouse.
          notify.innerHTML = 'Notify me<span class="cm-card-notify-where"> when ' + where + ' has stock</span>';
          notify.setAttribute('data-notify-location', where);
        }
        if (outRows.length === 1) outRows[0].insertAdjacentElement('afterend', notify);
        else stockRows[1].parentElement.appendChild(notify);
      }
    }

    // Phone table view (2026-10-04, Akshay Change 1): one grey line under the title,
    // "17×8 · 5-114.3 · 45 · AC04-17080-5450-45S". Built once the specs have arrived.
    if (!item.querySelector('.cm-spec-line') && item.querySelector('.card-specs')) {
      var parts = [];
      item.querySelectorAll('.card-specs .card-spec').forEach(function (spec, i) {
        if (i === 2) return;   // finish is already in the title
        var v = spec.querySelector('.card-spec-value');
        if (v && v.textContent.trim()) parts.push(v.textContent.trim());
      });
      var skuV = item.querySelector('.cm-card-codes .sku-value');
      if (skuV && skuV.textContent.trim()) parts.push(skuV.textContent.trim());
      var det = item.querySelector('.cm_product-item__details');
      if (parts.length && det) {
        var line = document.createElement('div');
        line.className = 'cm-spec-line';
        line.textContent = parts.join(' · ');
        det.appendChild(line);
      }
    }

    if (!item.querySelector('.cm-row-check') && loggedIn()) {
      var check = document.createElement('label');
      check.className = 'cm-row-check';
      check.innerHTML = '<input type="checkbox" data-plp-select aria-label="Select for bulk add">';
      item.insertBefore(check, item.firstChild);
    }
  }

  /* ---------------------------------------------------------- toolbar */
  /* Convermax keeps totalHits on its search response. Rewriting the hits
     text node detaches that binding, so the toolbar stayed on "2 wheels"
     after a chip or the search pill was cleared even though the grid updated. */
  function readTotalHits(hits) {
    try {
      if (window.Convermax && typeof window.Convermax.getSearchResponse === 'function') {
        var resp = window.Convermax.getSearchResponse();
        if (resp && typeof resp.totalHits === 'number' && !isNaN(resp.totalHits)) return resp.totalHits;
      }
    } catch (e) {}
    if (!hits) return null;
    /* Ignore our own label so a stale "2 wheels" cannot win over Convermax's node. */
    var clone = hits.cloneNode(true);
    clone.querySelectorAll('.cm-hits-count, .cm-hits-context, .cm-total-hits-prefix').forEach(function (n) { n.remove(); });
    var m = (clone.textContent || '').match(/(\d[\d,]*)/);
    return m ? parseInt(m[1].replace(/,/g, ''), 10) : null;
  }

  function syncToolbarHits() {
    var hits = document.querySelector('.cm_SearchHeader .cm_total-hits');
    if (!hits) return;
    var count = readTotalHits(hits);
    var num = hits.querySelector('.cm-hits-count');
    if (!num) {
      num = document.createElement('span');
      num.className = 'cm-hits-count';
      hits.insertBefore(num, hits.firstChild);
    }
    if (count != null) {
      var label = count + (count === 1 ? ' wheel' : ' wheels');
      if (num.textContent !== label) num.textContent = label;
    }
    var v = vehicleFromUrl();
    var ctx = hits.querySelector('.cm-hits-context');
    if (v && !ctx) {
      ctx = document.createElement('span');
      ctx.className = 'cm-hits-context';
      hits.appendChild(ctx);
    }
    if (ctx) ctx.textContent = v ? ' for ' + vehicleLabel(v) : '';
    if (!v && ctx) ctx.textContent = '';
    hits.classList.add('is-plp-hits');
  }

  function upgradeToolbar() {
    var header = document.querySelector('.cm_SearchHeader');
    if (!header) return;

    syncToolbarHits();

    if (!header.querySelector('.cm-results-search')) {
      var form = document.createElement('form');
      form.className = 'cm-results-search';
      form.action = '/pages/search';
      form.method = 'get';
      form.setAttribute('role', 'search');
      form.innerHTML = SEARCH_SVG + '<input type="search" name="query" placeholder="Search within results — part #, SKU, UPC" aria-label="Search within results">';
      var sort = header.querySelector('.cm_sort');
      if (sort) header.insertBefore(form, sort); else header.appendChild(form);
    }

    // Price-mode indicator (moved here from the header)
    var root = document.documentElement;
    var mode = root.classList.contains('pricing-catalog') ? 'catalog' : root.classList.contains('pricing-retail') ? 'retail' : '';
    var modePill = header.querySelector('.plp-mode-pill');
    if (!modePill) { modePill = document.createElement('span'); modePill.className = 'plp-mode-pill'; header.appendChild(modePill); }
    modePill.hidden = !mode;
    modePill.className = 'plp-mode-pill' + (mode ? ' is-' + mode : '');
    modePill.textContent = mode === 'catalog' ? 'Catalog Mode' : mode === 'retail' ? 'Retail Mode' : '';
    modePill.title = mode === 'catalog' ? 'Catalog Mode: all pricing hidden' : mode === 'retail' ? 'Retail Mode: MAP pricing shown, wholesale hidden' : '';

    header.querySelectorAll('.collection-view-toggle-btn[data-view="list"] span').forEach(function (s) {
      if (s.textContent.trim() === 'List') s.textContent = 'Table';
    });
  }

  /* Convermax keeps the selected vehicle in localStorage (cm_variant-model); the
     garage list (cm_variant-garage) is left alone. */
  function forgetVehicle() {
    try { localStorage.removeItem('cm_variant-model'); } catch (e) {}
    try { localStorage.removeItem('cm_selected_vehicle'); } catch (e) {}
  }

  /* ---------------------------------------------------------- sidebar */
  function upgradeSidebar() {
    var panel = document.querySelector('.cm_FacetPanel');
    var heading = panel && panel.querySelector('.sidebar-filter-heading');
    if (!panel || !heading) return;

    if (!heading.querySelector('.cm-clear-all')) {
      var clear = document.createElement('button');
      clear.type = 'button';
      clear.className = 'cm-clear-all';
      clear.hidden = true;
      clear.addEventListener('click', function () {
        // Facets live in the URL; Convermax re-applies the remembered vehicle from
        // localStorage on load. Forget it and load the bare path once, so the
        // vehicle and the filters clear together (Issue 6: they used to clear in
        // two steps through the vehicle widget).
        forgetVehicle();
        document.body.classList.add('is-plp-clearing');
        window.location.href = window.location.pathname;
      });
      heading.appendChild(clear);
    }
    // Fitment is a filter too: show it as the first chip. Removing it drops the
    // Year/Make/Model segments from the URL (Convermax's own chips do not cover it).
    var chipsWrap = panel.querySelector('.cm_FilterChips');
    var vehicle = vehicleFromUrl();
    if (chipsWrap) {
      var fitChip = chipsWrap.querySelector('.cm-fit-chip');
      if (vehicle && !fitChip) {
        fitChip = document.createElement('button');
        fitChip.type = 'button';
        fitChip.className = 'cm-fit-chip';
        fitChip.innerHTML = CHECK_SVG + '<span>Fits ' + vehicleLabel(vehicle) + '</span><span class="cm-fit-chip-x" aria-hidden="true">×</span>';
        fitChip.setAttribute('aria-label', 'Remove vehicle filter');
        fitChip.addEventListener('click', function () {
          var parts = window.location.search.replace(/^\?/, '').split('&')[0].split('/');
          var out = [];
          for (var i = 0; i < parts.length; i++) {
            if (parts[i] === 'Year' || parts[i] === 'Make' || parts[i] === 'Model') { i++; continue; }
            if (parts[i] === 'Fitment' && parts[i + 1] === 'Vehicle-Specific') { i++; continue; }
            if (parts[i]) out.push(parts[i]);
          }
          // Same recipe as Clear all: forget the remembered vehicle, then load once.
          forgetVehicle();
          document.body.classList.add('is-plp-clearing');
          window.location.href = window.location.pathname + (out.length ? '?' + out.join('/') : '');
        });
        chipsWrap.insertBefore(fitChip, chipsWrap.firstChild);
      } else if (!vehicle && fitChip) {
        fitChip.remove();
      }
      chipsWrap.classList.toggle('has-chips', !!chipsWrap.querySelector('.cm-fit-chip, .cmTemplate_chip, .facetdiv'));
    }
    var chips = document.querySelectorAll('.cm_FilterChips .cmTemplate_chip, .cm_FilterChips .facetdiv');
    var count = [].slice.call(chips).filter(function (c) { return !/start over/i.test(c.textContent); }).length + (vehicle ? 1 : 0);
    var clearBtn = heading.querySelector('.cm-clear-all');
    clearBtn.hidden = count === 0;
    clearBtn.textContent = 'Clear all (' + count + ')';

    if (!panel.querySelector('.cm-facet-search')) {
      var box = document.createElement('div');
      box.className = 'cm-facet-search';
      box.innerHTML = SEARCH_SVG + '<input type="search" placeholder="Search filters (e.g. 20x9, chrome)" aria-label="Search filters">';
      // Inside the heading so the title, Clear all and this box pin together (PLP-17).
      heading.appendChild(box);
      var input = box.querySelector('input');
      input.addEventListener('input', function () {
        var q = input.value.trim().toLowerCase();
        document.querySelectorAll('.cm_Facets .facetholder').forEach(function (f) {
          if (!q) { f.classList.remove('is-filtered-out'); f.querySelectorAll('.facetdiv').forEach(function (d) { d.classList.remove('is-filtered-out'); }); return; }
          var titleHit = (f.querySelector('.facettitle') || {}).textContent.toLowerCase().indexOf(q) >= 0;
          var any = titleHit;
          f.querySelectorAll('.facetdiv').forEach(function (d) {
            var hit = titleHit || d.textContent.toLowerCase().indexOf(q) >= 0;
            d.classList.toggle('is-filtered-out', !hit);
            if (hit) any = true;
          });
          f.classList.toggle('is-filtered-out', !any);
          if (any && !titleHit) f.classList.add('is-search-open');
        });
      });
    }
  }

  /* ------------------------------------------------------- table view */
  /* Issue 9: table view only. One delegated listener on the results container,
     because Convermax replaces the rows on paging and filtering. The preview is
     position:fixed, so the row does not grow. The large CDN image is requested
     on the first hover of that src. */
  function ensureTableZoom() {
    var results = document.querySelectorAll('.cm_SearchResult');
    if (!results.length) return;
    var fine = window.matchMedia('(hover: hover) and (pointer: fine)');

    function previewEl() {
      var preview = document.getElementById('cm-table-zoom');
      if (preview) return preview;
      preview = document.createElement('img');
      preview.id = 'cm-table-zoom';
      preview.className = 'cm-table-zoom';
      preview.alt = '';
      preview.setAttribute('aria-hidden', 'true');
      preview.hidden = true;
      document.body.appendChild(preview);
      return preview;
    }

    /* In table view the hover-swap secondary image sits on top of the primary,
       so the pointer is usually over the secondary. Key on the image box and
       zoom the image that is showing (the last visible one in the box). */
    function rowImage(target) {
      if (!target || !target.closest) return null;
      if (target.id === 'cm-table-zoom') return null;
      var box = target.closest('.cm_product-item__image-container');
      if (!box || !box.closest('.cm_product-item')) return null;
      var imgs = box.querySelectorAll('img');
      for (var i = imgs.length - 1; i >= 0; i--) {
        var style = window.getComputedStyle(imgs[i]);
        if (style.display !== 'none' && style.visibility !== 'hidden' && parseFloat(style.opacity) > 0) return imgs[i];
      }
      return imgs[0] || null;
    }

    function zoomSrc(img) {
      var src = img.currentSrc || img.getAttribute('src') || '';
      if (!src) return '';
      try {
        var url = new URL(src, window.location.href);
        url.searchParams.set('width', '640');
        return url.toString();
      } catch (e) {
        return src;
      }
    }

    function place(preview, x, y) {
      var size = 320;
      var gap = 16;
      var left = x + gap;
      var top = y - size / 2;
      if (left + size > window.innerWidth - 8) left = x - gap - size;
      if (left < 8) left = Math.max(8, window.innerWidth - size - 8);
      if (top + size > window.innerHeight - 8) top = window.innerHeight - size - 8;
      if (top < 8) top = 8;
      preview.style.left = left + 'px';
      preview.style.top = top + 'px';
    }

    function canZoom() {
      return document.body.classList.contains('collection-view-list') && fine.matches;
    }

    function show(img, x, y) {
      if (!canZoom()) return;
      var src = zoomSrc(img);
      if (!src) return;
      var preview = previewEl();
      if (preview.getAttribute('data-src') !== src) {
        preview.setAttribute('data-src', src);
        preview.src = src;
      }
      place(preview, x, y);
      preview.hidden = false;
    }

    function hide() {
      var preview = document.getElementById('cm-table-zoom');
      if (preview) preview.hidden = true;
    }

    [].forEach.call(results, function (resultsEl) {
      if (resultsEl.getAttribute('data-cm-zoom-bound') === '1') return;
      resultsEl.setAttribute('data-cm-zoom-bound', '1');
      resultsEl.addEventListener('mouseover', function (event) {
        var img = rowImage(event.target);
        if (!img || rowImage(event.relatedTarget) === img) return;
        show(img, event.clientX, event.clientY);
      });
      resultsEl.addEventListener('mousemove', function (event) {
        var preview = document.getElementById('cm-table-zoom');
        if (!preview || preview.hidden) return;
        if (!canZoom() || !rowImage(event.target)) {
          preview.hidden = true;
          return;
        }
        place(preview, event.clientX, event.clientY);
      });
      resultsEl.addEventListener('mouseout', function (event) {
        var img = rowImage(event.target);
        if (!img || rowImage(event.relatedTarget) === img) return;
        hide();
      });
    });
  }

  function ensureTableHead() {
    var items = document.querySelector('.cm_SearchResult .cmRepeater_items');
    if (!items || !items.parentElement) return;
    if (items.parentElement.querySelector('.cm-table-head')) return;
    var head = document.createElement('div');
    head.className = 'cm-table-head';
    var cols = ['', '', 'Style / finish', 'SKU / UPC', 'Size', 'Bolt', 'Offset', 'FL', 'TX', '<span class="cm-th-price-default">Price</span><span class="cm-th-price-retail">Retail price</span>', 'Qty', ''];
    head.innerHTML = cols.map(function (c, i) {
      var cls = 'cm-th cm-th-' + (i + 1);
      return '<div class="' + cls + '">' + c + '</div>';
    }).join('');
    items.parentElement.insertBefore(head, items);
  }

  function ensureBulkBar() {
    var results = document.querySelector('.cm_SearchResult');
    if (!results || !loggedIn() || document.querySelector('.cm-bulk-bar')) return;
    var bar = document.createElement('div');
    bar.className = 'cm-bulk-bar';
    bar.hidden = true;
    bar.innerHTML =
      '<b class="cm-bulk-count">0 selected</b>' +
      '<span class="cm-bulk-label">Quantity each</span>' +
      '<div class="cm-bulk-presets"><button type="button" data-q="1">1</button><button type="button" class="is-active" data-q="4">4</button><button type="button" data-q="8">8</button></div>' +
      '<button type="button" class="cm-bulk-add">' + CART_SVG + '<span>Add selected to cart</span></button>' +
      '<button type="button" class="cm-bulk-clear">Clear</button>';
    results.insertBefore(bar, results.firstChild);

    var qty = 4;
    function setEachQty(next) {
      qty = next;
      document.querySelectorAll('.cm_product-item').forEach(function (item) {
        item.querySelectorAll('input[name="quantity"], .cm-card-qty-input').forEach(function (input) {
          input.value = String(next);
        });
      });
    }
    bar.querySelectorAll('[data-q]').forEach(function (b) {
      b.addEventListener('click', function () {
        setEachQty(parseInt(b.dataset.q, 10) || 1);
        bar.querySelectorAll('[data-q]').forEach(function (x) { x.classList.toggle('is-active', x === b); });
      });
    });
    bar.querySelector('.cm-bulk-clear').addEventListener('click', function () {
      document.querySelectorAll('[data-plp-select]:checked').forEach(function (c) { c.checked = false; });
      refreshBulk();
    });
    bar.querySelector('.cm-bulk-add').addEventListener('click', function () {
      var rows = [].slice.call(document.querySelectorAll('[data-plp-select]:checked')).map(function (c) {
        var item = c.closest('.cm_product-item');
        var idInput = item && item.querySelector('form input[name="id"]');
        // The visible box, not the hidden field: Convermax resets that to 1 when it redraws for a vehicle.
        var qtyInput = item && (item.querySelector('.cm-card-qty-input') || item.querySelector('form input[name="quantity"]'));
        var rowQty = qtyInput ? parseInt(qtyInput.value, 10) : qty;
        if (!rowQty || rowQty < 1) rowQty = qty || 1;
        return {
          id: idInput ? parseInt(idInput.value, 10) : null,
          sku: skuLabel(item),
          qty: rowQty,
        };
      }).filter(function (row) { return row.id; });
      if (!rows.length) return;
      var btn = bar.querySelector('.cm-bulk-add');
      var label = btn.querySelector('span');
      btn.disabled = true;

      function resetLabel() {
        setTimeout(function () { label.textContent = 'Add selected to cart'; }, 2000);
      }
      function clearSelection() {
        document.querySelectorAll('[data-plp-select]:checked').forEach(function (c) { c.checked = false; });
        refreshBulk();
      }
      function requestedUnits() {
        return rows.reduce(function (sum, row) { return sum + row.qty; }, 0);
      }
      function succeed() {
        if (window.miniCart && window.miniCart.updateSectionContents) window.miniCart.updateSectionContents();
        if (window.miniCart && window.miniCart.open) window.miniCart.open(btn);
        var same = rows.every(function (row) { return row.qty === rows[0].qty; });
        label.textContent = same ? ('Added ' + rows.length + ' × ' + rows[0].qty) : ('Added ' + requestedUnits());
        resetLabel();
        clearSelection();
        if (window.cartStockNotice) window.cartStockNotice.fetchCart();
      }
      function couldNotAdd() {
        label.textContent = 'Could not add';
        resetLabel();
      }

      var notice = window.cartStockNotice;
      // A cold cart cache has to be read before the request, so a refused bulk
      // add cannot be followed by a second add of units Shopify already took.
      var ready = notice && !notice.cachedQtyMap() ? notice.fetchCart() : Promise.resolve();
      ready.then(function () {
      var beforeMap = notice ? notice.cachedQtyMap() : null;
      var beforeKnown = !!beforeMap;

      return fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          // Without this header a {id, quantity} body adds past stock. The
          // items body also enforces stock; the header is sent on both.
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify({ items: rows.map(function (row) { return { id: row.id, quantity: row.qty }; }) }),
      })
        .then(function (r) {
          if (r.ok) return r.json().then(succeed);
          if (r.status !== 422) {
            couldNotAdd();
            return;
          }
          return r.json().catch(function () { return {}; }).then(function () {
            return addSelectedOneByOne(beforeMap, beforeKnown);
          });
        })
        .catch(couldNotAdd);
      }).catch(couldNotAdd).finally(function () { btn.disabled = false; });

      function postOne(id, quantity) {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            // {id, quantity} without this header returns 200 and adds past stock.
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: JSON.stringify({ id: id, quantity: quantity }),
        }).then(function (r) {
          if (r.status >= 500) {
            var error = new Error('add failed');
            error.http = r.status;
            throw error;
          }
          return r.json().catch(function () { return {}; });
        });
      }

      function addSelectedOneByOne(knownBefore, hasBefore) {
        var chain = Promise.resolve();
        var hardFail = false;
        var attempted = {};
        var prepare = notice ? notice.fetchCart() : Promise.resolve(null);
        return prepare.then(function (midCart) {
          var midMap = notice && midCart ? notice.qtyMap(midCart) : null;
          rows.forEach(function (row) {
            chain = chain.then(function () {
              if (hardFail) return;
              var baseline = hasBefore && knownBefore ? (knownBefore[String(row.id)] || 0) : 0;
              var current = midMap ? (midMap[String(row.id)] || 0) : baseline;
              var already = Math.max(0, current - baseline);
              var remain = row.qty - already;
              attempted[row.id] = true;
              if (remain <= 0) return;
              return postOne(row.id, remain).then(function () {
                if (!notice) return;
                return notice.fetchCart().then(function (cart) {
                  if (cart) midMap = notice.qtyMap(cart);
                });
              }).catch(function () {
                hardFail = true;
              });
            });
          });
          return chain.then(function () {
            var afterFetch = notice ? notice.fetchCart() : Promise.resolve(null);
            return afterFetch.then(function (afterCart) {
              var afterMap = afterCart && notice ? notice.qtyMap(afterCart) : null;
              var compare = afterMap || midMap;
              var units = 0;
              var lines = [];
              rows.forEach(function (row) {
                if (!attempted[row.id]) return;
                // Count units from the cart before this bulk add and after it.
                // Do not trust the requested remainder: a 200 without the Ajax
                // header would have added that remainder past stock.
                var got = 0;
                if (compare && hasBefore && knownBefore) {
                  got = Math.max(0, (compare[String(row.id)] || 0) - (knownBefore[String(row.id)] || 0));
                }
                units += got;
                if (got < row.qty && notice) lines.push(notice.shortLine(got, row.qty, row.sku));
              });
              if (hardFail && units === 0) {
                couldNotAdd();
                return;
              }
              label.textContent = 'Added ' + units + ' of ' + requestedUnits();
              // Clearing now would hide the bar, so the count would never be readable.
              setTimeout(function () {
                label.textContent = 'Add selected to cart';
                clearSelection();
              }, 2000);
              if (!notice) return;
              if (lines.length) return notice.openMiniCartWithMessage(lines.join('\n'), btn);
              return notice.refreshMiniCart().then(function () {
                if (window.miniCart && window.miniCart.open) window.miniCart.open(btn);
              });
            });
          });
        });
      }
    });
  }

  function refreshBulk() {
    var bar = document.querySelector('.cm-bulk-bar');
    if (!bar) return;
    var n = document.querySelectorAll('[data-plp-select]:checked').length;
    bar.hidden = n === 0;
    bar.querySelector('.cm-bulk-count').textContent = n + ' selected';
    // Table view: the pinned column header sits under the pinned bar.
    document.documentElement.style.setProperty('--plp-bulk-h', (n === 0 ? 0 : Math.round(bar.getBoundingClientRect().height)) + 'px');
    document.querySelectorAll('.cm_product-item').forEach(function (item) {
      var c = item.querySelector('[data-plp-select]');
      item.classList.toggle('is-selected', !!(c && c.checked));
    });
  }
  document.addEventListener('change', function (e) {
    if (e.target && e.target.matches && e.target.matches('[data-plp-select]')) refreshBulk();
  });

  /* ---------------------------------------------------- search boxes */
  /* Issue 4: the header search and "Search within results" keep the query that
     is on screen, with an X that clears it and brings back every result. The
     query is read from Convermax, so removing the Query chip empties the boxes too. */
  var CLEAR_SVG =
    '<svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M5 5l10 10M15 5L5 15"/></svg>';

  function activeQuery() {
    try {
      if (window.Convermax && typeof window.Convermax.getSearchRequest === 'function') {
        var req = window.Convermax.getSearchRequest();
        if (req && typeof req.query === 'string') return req.query.trim();
      }
    } catch (e) {}
    if (window.location.pathname.indexOf('/pages/search') === 0) {
      try { return (new URLSearchParams(window.location.search).get('query') || '').trim(); } catch (e) {}
    }
    return '';
  }

  function clearActiveQuery() {
    var chip = [].slice.call(document.querySelectorAll('.cm_FilterChips .cmTemplate_chip')).filter(function (c) {
      return /^\s*Query:/.test(c.textContent);
    })[0];
    if (chip) { (chip.querySelector('.facetentrykey') || chip).click(); return; }
    if (activeQuery()) window.location.href = '/pages/search';
  }

  function searchInputs() {
    return [].slice.call(document.querySelectorAll('.head-search__input, .cm-results-search input[name="query"]'));
  }

  function ensureClearButton(input) {
    var form = input.form || input.parentElement;
    if (!form || form.querySelector('.cm-search-clear')) return;
    form.classList.add('has-search-clear');
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'cm-search-clear';
    btn.setAttribute('aria-label', 'Clear search');
    btn.hidden = !input.value;
    btn.innerHTML = CLEAR_SVG;
    input.insertAdjacentElement('afterend', btn);
    input.addEventListener('input', function () { btn.hidden = !input.value; });
    btn.addEventListener('click', function () {
      var hadQuery = !!activeQuery();
      searchInputs().forEach(function (i) { i.value = ''; i.dataset.cmSyncedQuery = ''; });
      document.querySelectorAll('.cm-search-clear').forEach(function (b) { b.hidden = true; });
      if (hadQuery) clearActiveQuery(); else input.focus();
    });
  }

  function syncSearchBoxes() {
    var q = activeQuery();
    searchInputs().forEach(function (input) {
      ensureClearButton(input);
      if (document.activeElement !== input && input.dataset.cmSyncedQuery !== q) {
        input.value = q;
        input.dataset.cmSyncedQuery = q;
      }
      var btn = (input.form || input.parentElement).querySelector('.cm-search-clear');
      if (btn) btn.hidden = !input.value;
    });
  }

  /* --------------------------------------------------- sticky offsets */
  // The site header is sticky; the facet panel and the table header pin
  // beneath it. Publish its live height as a CSS variable so the panel's own
  // scroll region is exactly the visible space (top offset + max-height).
  function publishStickyOffsets() {
    var h = document.querySelector('[id^="shopify-section-"][class*="section-header"]');
    var headerBottom = h ? Math.max(0, Math.round(h.getBoundingClientRect().bottom)) : 0;
    var root = document.documentElement;
    root.style.setProperty('--plp-header-h', headerBottom + 'px');
    // Before the panel is pinned it sits lower than the header; size its scroll
    // region from wherever its top edge currently is, so the bottom always
    // lands at the viewport edge and the last facet group is reachable.
    var panel = document.querySelector('.cm_FacetPanel');
    if (panel) {
      var top = Math.max(headerBottom, Math.round(panel.getBoundingClientRect().top));
      root.style.setProperty('--plp-panel-top', top + 'px');
    }
  }
  publishStickyOffsets();
  window.addEventListener('resize', publishStickyOffsets);
  window.addEventListener('scroll', publishStickyOffsets, { passive: true });
  document.addEventListener('DOMContentLoaded', publishStickyOffsets);

  /* ----------------------------------------------- mobile filter dialog */
  /* Convermax portals FacetDialog with its own dialog classes. Desktop
     sidebar offsets (min-height, negative margin, 85vw sheet) clip the
     left of every label on a phone. Tag the open dialog so CSS can reset it. */
  function filterDialogRoot(panel) {
    var node = panel.parentElement;
    var found = null;
    while (node && node !== document.body && node !== document.documentElement) {
      var cls = node.className && typeof node.className === 'string' ? node.className : '';
      if (/dialog/i.test(cls)) found = node;
      node = node.parentElement;
    }
    return found;
  }

  function elementShown(el) {
    if (!el || !el.isConnected) return false;
    var cs = window.getComputedStyle(el);
    if (cs.display === 'none' || cs.visibility === 'hidden') return false;
    var r = el.getBoundingClientRect();
    return r.width > 40 && r.height > 40;
  }

  function fixFilterDialog() {
    var narrow = window.matchMedia('(max-width: 1024px)').matches;
    /* The page has two .cm_FacetPanel elements: the sidebar (hidden on phones) comes first,
       the dialog's panel second. Prefer the one inside the Convermax dialog. */
    var panel = document.querySelector('.cm_dialog .cm_FacetPanel') || document.querySelector('.cm_FacetPanel');
    var dialog = panel ? filterDialogRoot(panel) : null;
    var open = narrow && dialog && elementShown(dialog) && elementShown(panel);
    document.querySelectorAll('.is-plp-filter-dialog').forEach(function (el) {
      if (el !== dialog || !open) el.classList.remove('is-plp-filter-dialog');
    });
    document.querySelectorAll('.is-plp-filter-panel').forEach(function (el) {
      if (el !== panel || !open) el.classList.remove('is-plp-filter-panel');
    });
    if (!open) return;
    dialog.classList.add('is-plp-filter-dialog');
    panel.classList.add('is-plp-filter-panel');
  }

  document.addEventListener('click', function (event) {
    var opener = event.target && event.target.closest
      ? event.target.closest('.cm_facetDialogButton, .cm_dialogButton, .cm_facet-dialog_button-done, .cm_facet-dialog_button-clear')
      : null;
    if (!opener) return;
    setTimeout(function () { try { fixFilterDialog(); } catch (e) {} }, 50);
    setTimeout(function () { try { fixFilterDialog(); } catch (e) {} }, 300);
  });

  /* -------------------------------------------------------------- run */
  var scheduled = false;
  var hitsTimer = null;
  // Back in stock from a card: same dealer App Proxy as the PDP buttons (main-product-purchase-panel).
  document.addEventListener('click', function (ev) {
    var el = ev.target.closest('[data-plp-notify]');
    if (!el) return;
    ev.preventDefault();
    ev.stopPropagation();
    if (el.dataset.busy === '1' || el.classList.contains('is-done')) return;
    var item = el.closest('.cm_product-item');
    var extras = item && item.__cmExtras;
    var idInput = item && item.querySelector('input[name="id"]');
    if (!extras || !extras.id || !idInput || !idInput.value) return;
    el.dataset.busy = '1';
    var original = el.innerHTML;
    el.textContent = 'Saving…';
    fetch('/apps/dealer/notify-me', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ product_id: String(extras.id), variant_id: idInput.value, location: el.getAttribute('data-notify-location') || 'any' })
    })
      .then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { return { s: r.status, b: j }; }); })
      .then(function (res) {
        if (res.s === 200 && res.b.ok) {
          var where = res.b.location && res.b.location !== 'any' ? res.b.location.charAt(0).toUpperCase() + res.b.location.slice(1) : null;
          el.innerHTML = "We'll email you" + (where ? '<span class="cm-card-notify-where"> when ' + where + ' has stock</span>' : '<span class="cm-card-notify-where"> when it\'s back</span>');
          el.classList.add('is-done');
          return;
        }
        el.dataset.busy = '';
        el.textContent = res.s === 401 ? 'Please sign in first' : 'Try again';
        setTimeout(function () { el.innerHTML = original; }, 4000);
      })
      .catch(function () {
        el.dataset.busy = '';
        el.textContent = 'Try again';
        setTimeout(function () { el.innerHTML = original; }, 4000);
      });
  }, true);

  function run() {
    scheduled = false;
    try { upgradeToolbar(); } catch (e) {}
    try { upgradeSidebar(); } catch (e) {}
    try { ensureTableHead(); } catch (e) {}
    try { ensureTableZoom(); } catch (e) {}
    try { ensureBulkBar(); } catch (e) {}
    try { fixFilterDialog(); } catch (e) {}
    try { syncSearchBoxes(); } catch (e) {}
    document.querySelectorAll('.cm_product-item').forEach(function (item) {
      try { upgradeCard(item); lateUpgrades(item); } catch (e) {}
    });
  }
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(run);
    /* The response total can land a tick after the grid DOM swap. */
    clearTimeout(hitsTimer);
    hitsTimer = setTimeout(function () { try { syncToolbarHits(); fixFilterDialog(); syncSearchBoxes(); } catch (e) {} }, 300);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
})();
